/* eslint-disable one-var */
function decodeURIComponentSafe (uri, mod) {
  // eslint-disable-next-line no-new-wrappers
  var out = new String()
  var arr
  var i = 0
  var l
  var x
  // eslint-disable-next-line no-unused-expressions
  typeof mod === 'undefined' ? mod = 0 : 0
  arr = uri.split(/(%(?:d0|d1)%.{2})/)
  for (l = arr.length; i < l; i++) {
    try {
      x = decodeURIComponent(arr[i])
    } catch (e) {
      x = mod ? arr[i].replace(/%(?!\d+)/g, '%25') : arr[i]
    }
    out += x
  }
  return out
}
function getUrlParameter (name) {
  /* eslint-disable */
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  /* eslint-enable */
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  return results === null
    ? ''
    : decodeURIComponentSafe(results[1].replace(/\+/g, ' '))
}

export default getUrlParameter



// WEBPACK FOOTER //
// ./src/shared/geturlparamter.js